import Ax from './axios';
import config from './config';

const API = config.BASE_API;

// 文档 http://wiki.cheyaoshicorp.com/pages/viewpage.action?pageId=33953056

export function getLoginUserInfo() {
  return Ax.get(`${API}/account/info`);
}

export function userLogin(data) {
  return Ax.post(`${API}/login`, data);
}

export function createUser(data) {
  return Ax.post(`${API}/user/update`, data);
}

export function modifyUser(data) {
  return Ax.post(`${API}/user/modifyUserCity`, data);
}

export function changeUserStatus(data) {
  return Ax.put(`${API}/user/status`, data);
}

export function getUserList(params) {
  return Ax.get(`${API}/user/table`, { params });
}

export function getPermissionCityList(params) {
  return Ax.get(`${API}/city/bind/permission`, { params });
}

export function getCityListByPage(params) {
  return Ax.get(`${API}/city/table`, { params });
}

export function getCityList(params) {
  return Ax.get(`${API}/common/allCityList`, { params });
}

export function getScenicCityList(params) {
  return Ax.get(`${API}/city/scenic`, { params });
}

export function getScenicList(params) {
  return Ax.get(`${API}/common/scenic`, { params });
}

export function getUserPermission(params) {
  return Ax.get(`${API}/role/permission`, { params });
}

export function getPermissionList() {
  return Ax.get(`${API}/permission/table`);
}

export function changePermission(data) {
  return Ax.post(`${API}/role/update`, data);
}

export function setBikeNumber(data) {
  return Ax.post(`${API}/city/bike/amount`, data);
}

export function dataLimit(data) {
  return Ax.post(`${API}/city/data/limit`, data);
}

export function getRoleList(params) {
  return Ax.get(`${API}/role/table`, { params });
}

export function getAllRole() {
  return Ax.get(`${API}/role/all`);
}

export function setFixedBicycle(data) {
  return Ax.post(`${API}/city/setFixedBicycle`, data);
}

export function setBicycleDataLimit(data) {
  return Ax.post(`${API}/city/setBicycleDataLimit`, data);
}
export function queryCityFixedCount(params) {
  return Ax.get(`${API}/city/queryCityFixedCount`, { params });
}



// WEBPACK FOOTER //
// ./src/api/user.js